import type { AnswerStatus } from '@coorum-research/shared-common/types'

export type QueryParam = {
  key: string
  value: string
}

export function addQueryParams(url: string, params: QueryParam[]): string {
  const urlObj = new URL(url)

  params.forEach((param) => {
    urlObj.searchParams.append(param.key, param.value)
  })

  return urlObj.toString()
}

// 回答ステータス = doneの場合に、クエリパラメータを追加したURLを新しいタブで開く
export function openMyPageTabUrlWithQueryParams(
  baseUrl: string,
  params: QueryParam[],
  answerStatus: AnswerStatus,
  target: string = '_blank',
  features: string = 'noopener',
): Window | undefined {
  if (!baseUrl || answerStatus !== 'done') {
    return undefined
  }

  const url = addQueryParams(baseUrl, params)
  if (url) {
    return window.open(url, target, features) || undefined
  }

  return undefined
}
